<template>
    <v-sheet
            tabindex="0"
            :title="title"
            :color="color"
            width="100%"
            height="200"
            dark
            @click="openFileSelect"
            @dragenter.prevent="onDragover(true, $event)"
            @dragover.prevent="onDragover(true, $event)"
            @dragleave.prevent="onDragover(false, $event)"
            @drop.prevent="onDrop($event)"
            style="cursor:pointer;"
    >
        <input
            ref="input"
            type="file"
            :accept="accept.join(',')"
            :multiple="multiple"
            style="display: none"
            @change="updateFileSelect"
        />
        <v-container
            fill-height
            grid-list
            style="pointer-events: none"
        >
            <v-layout
                column
                align-center
                justify-center
            >
                <div
                    class="subtitle-1"
                    v-if="value && value.length > 0"
                    style="display: flex"
                >
                    <div
                        v-for="(file, idx) in value"
                        :key="idx"
                        style="display: flex; flex-direction: column"
                    >
                        <img v-if="preview" :src="createUrl(file)" :alt="file.name" width="60px">
                        {{ file.name }}
                    </div>
                </div>
                <div
                    class="subtitle-1"
                    v-else
                >
                    {{ title }}
                </div>
                <v-icon
                    v-if="dragover && valid"
                >
                    mdi-check
                </v-icon>
                <v-btn
                    fab
                    icon
                    v-else-if="dragover && !valid"
                >
                    <v-icon>
                        mdi-close
                    </v-icon>
                </v-btn>
            </v-layout>
        </v-container>
    </v-sheet>
</template>

<script>
    export default {
        props: {
            value: {},
            preview: {
                type: Boolean,
                default: false,
            },
            label: {
                type: String,
            },
            accept: {
                type: Array,
                default: function () {
                    return [
                        '*/*'
                    ];
                },
            },
            regex: {
                type: Array,
                default: function () {
                    return [
                        '.*'
                    ];
                },
            },
            multiple: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                dragover: false,
                valid: true,
            };
        },
        computed: {
            title() {
                return this.$t('upload.title', { label: this.label });
            },
            color() {
                let color = 'primary lighten-5';
                if(!this.valid && this.dragover) {
                    color = 'error';
                } else if(this.dragover) {
                    color = 'success';
                }
                return color;
            },
        },
        methods: {
            onDragover(dragover, event) {
                if(!dragover) {
                    this.valid = false;
                }
                // first validate file extensions
                if(dragover && !this.dragover && event.dataTransfer.items) {
                    let valid = true;
                    for(let j = 0, lj = event.dataTransfer.items.length; j < lj; j++) {
                        let fileValid = false;
                        for(let i = 0, l = this.accept.length; i < l; i++) {
                            if(
                                event.dataTransfer.items[j].type.match(this.regex[i])
                            ) {
                                fileValid = true;

                                break;
                            }
                        }

                        if(!fileValid) {
                            valid = false;
                        }
                    }

                    this.valid = valid;
                }
                this.dragover = dragover;
            },
            onDrop(event) {
                this.dragover = false;
                if(event.dataTransfer && this.valid) {
                    this.selectFiles(event.dataTransfer.files);
                    this.dragover = false;
                }
            },
            selectFiles(files) {
                this.$refs.input.files = files;
                this.$emit('input', files);
            },
            openFileSelect() {
                this.$refs.input.click();
            },
            updateFileSelect() {
                this.selectFiles(this.$refs.input.files);
            },
            reset() {
                this.$refs.input.value = null;
            },
            createUrl(file){
                return window.URL.createObjectURL(file);
            }
        },
    }
</script>
